import clsx from 'clsx';
import { Gauge, Globe, ShieldCheck, Smartphone, TabletSmartphone } from '@/components/icons';
import type { Platform } from '@1qa/shared';

export const PLATFORM_META: Record<Platform, { label: string; description: string; Icon: typeof Globe; tone: string }> = {
  WEB: {
    label: 'Web app',
    description: 'Any website - tested in Chrome, Firefox or Safari.',
    Icon: Globe,
    tone: 'bg-primary-subtle text-primary',
  },
  ANDROID: {
    label: 'Android app',
    description: 'Runs on an Android emulator.',
    Icon: Smartphone,
    tone: 'bg-primary-subtle text-primary',
  },
  IOS: {
    label: 'iOS app',
    description: 'Runs on an iPhone simulator.',
    Icon: TabletSmartphone,
    tone: 'bg-primary-subtle text-primary',
  },
  PERFORMANCE: {
    label: 'Performance',
    description: 'Many users at once on load agents: scripts, load plans and goals.',
    Icon: Gauge,
    tone: 'bg-primary-subtle text-primary',
  },
  SECURITY: {
    label: 'Security',
    description: 'Black-box penetration testing of a web app or API: scan configs, scope and an A–F grade.',
    Icon: ShieldCheck,
    tone: 'bg-primary-subtle text-primary',
  },
};

export function PlatformIcon({ platform, size = 'md' }: { platform: Platform; size?: 'sm' | 'md' | 'lg' }) {
  const m = PLATFORM_META[platform];
  return (
    <span
      className={clsx(
        // Figma UI kit icon tile (Iconography, node 1:3496): accent icon on #220F0D.
        'grid shrink-0 place-items-center',
        m.tone,
        size === 'sm' && 'size-8 rounded-lg',
        size === 'md' && 'size-11 rounded-lg',
        size === 'lg' && 'size-14 rounded-card',
      )}
      title={m.label}
    >
      <m.Icon className={size === 'lg' ? 'size-6' : size === 'sm' ? 'size-3.5' : 'size-4'} aria-hidden />
    </span>
  );
}
